import { ADD_NOTICE, ADD_NOTICE_FAILED, ADD_NOTICE_SUCCESS, NOTICE, NOTICE_FAILED, NOTICE_SUCCESS, UPDATE_NOTICE, UPDATE_NOTICE_FAILED, UPDATE_NOTICE_SUCCESS } from "./actionTypes"

let initialState = {
    notice: [],
    addNotice: "",
    updateNotice: "",
    loading: false,
    success: false,
    error: ''
}

export const noticeReducer = (state = initialState, action) => {
    switch (action.type) {

        case NOTICE: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case NOTICE_SUCCESS: return {
            ...state,
            notice: action.payload,
            loading: false,
            success: true
        }
        case NOTICE_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_NOTICE: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_NOTICE_SUCCESS: return {
            ...state,
            addNotice: action.payload,
            notice: [...state.notice, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_NOTICE_FAILED: return {
            ...state,
            addNotice: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_NOTICE: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_NOTICE_SUCCESS: return {
            ...state,
            updateNotice: action.payload,
            notice: state.notice.map((item) => item.id === action.payload._id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_NOTICE_FAILED: return {
            ...state,
            updateNotice: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}